import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Dashicon, Popover } from '@wordpress/components';
import classnames from 'classnames';
import { uniqueId, noop } from 'lodash';
import PropTypes from 'prop-types';

var DateInput = function DateInput(_ref) {
  var disabled = _ref.disabled,
      value = _ref.value,
      onChange = _ref.onChange,
      dateFormat = _ref.dateFormat,
      label = _ref.label,
      describedBy = _ref.describedBy,
      error = _ref.error,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      errorPosition = _ref.errorPosition;
  var classes = classnames('woocommerce-calendar__input', {
    'is-empty': value.length === 0,
    'is-error': error
  });
  var id = uniqueId('_woo-dates-input');
  return createElement("div", {
    className: classes
  }, createElement("input", {
    type: "text",
    className: "woocommerce-calendar__input-text",
    value: value,
    onChange: onChange,
    "aria-label": label,
    id: id,
    "aria-describedby": "".concat(id, "-message"),
    placeholder: dateFormat.toLowerCase(),
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    disabled: disabled
  }), error && createElement(Popover, {
    className: "woocommerce-calendar__input-error",
    focusOnMount: false,
    position: errorPosition
  }, error), createElement(Dashicon, {
    icon: "calendar"
  }), createElement("p", {
    className: "screen-reader-text",
    id: "".concat(id, "-message")
  }, error || describedBy));
};

DateInput.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  dateFormat: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  describedBy: PropTypes.string.isRequired,
  error: PropTypes.string,
  errorPosition: PropTypes.string,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func
};
DateInput.defaultProps = {
  disabled: false,
  onFocus: function onFocus() {},
  errorPosition: 'bottom center',
  onKeyDown: noop
};
export default DateInput;
//# sourceMappingURL=input.js.map